<template>
  <v-dialog
    v-model="dialogLocal"
    max-width="450px"
    @click:outside="dialogLocal = false"
  >
    <v-card>
      <v-card-title class="headline">
        Replicar o Mapeamento "{{items.nome}}"
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-row>
          <v-card-subtitle>Replicar para os seguintes sistemas</v-card-subtitle>
          <v-col cols="12" class="py-0">
            <v-checkbox
              v-for="item in sistemas" :key="item" 
              v-model="sistemaSelecionado"
              :label="item"
              color="primary"
              :value="item"
              :disabled="disabledCheckbox"
              hide-details
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="green darken-1"
          text
          @click="dialogLocal = false"
        >
          Fechar
        </v-btn>
        <v-btn
          color="green darken-1"
          :loading="loading"
          :disabled="disabled"
          @click="salvar()"
        >
          Replicar 
          <div v-if="contador > 0">
            ( {{contador}} )
          </div>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import Mapeamento from '@/services/MapeamentoService.js';

  export default {
    created(){
      this.contagemRegressiva()
    },

    data: () => ({
      sistemas:[],
      contador: 5,
      loading: false,
      disabled: true,
      geralCheckbox: true,
      sistemaSelecionado:[],
      disabledCheckbox: false,
    }),

    props: {
      items: {
        type: Object,
        default: ()=> {}
      },

      showDialog: {
        type: Boolean,
        default:false
      }
    },

    watch:{
      showDialog(newValue){
        if(newValue){
          this.getAllDatabases();

          // inicializar contagem regressiva.
          this.disabled = true;
          this.contador = 5;
          this.contagemRegressiva();
        } 
      }
    },

    computed: {
      dialogLocal: {
        get() {
          return this.showDialog;
        },
        set(newValue) {
          this.$emit('update:showDialog', newValue);
        }
      },
    },

    methods:{
      contagemRegressiva () {
        if (this.contador > 0) {
          setTimeout(() => {
            this.contador -= 1;
            this.contagemRegressiva();
          }, 1500)
        } else {
          this.disabled = false;
        }
      },

      getAllDatabases(){
        Mapeamento.getAllDatabases()
        .then(resp => {
          this.sistemas = Object.values(resp.data.data);
          this.sistemaSelecionado = Object.values(resp.data.data);
        })
        .catch(error => {
          console.error(error);
          this.$toast.error('Erro ao buscar Sistemas.', '',{position:'topRight'});
        });
      },

      salvar() {
        this.loading = true;
        this.disabledCheckbox = true;

        if (this.sistemaSelecionado == '') {
          this.$toast.info('Selecione ao menos um sistema', '',{position:'topRight'});
          this.loading = false;
          this.disabledCheckbox = false;
          return;
        }

        let data = {
          id: this.items.id,
          sistemas: this.sistemaSelecionado
        };
        Mapeamento.replicarMapeamento(data)
        .then(() => {
          this.dialogLocal = false;
          this.$toast.success('Mapeamento replicado com sucesso.', '', { position: 'topRight' });
        })
        .catch(error => {
          console.error(error);
          this.$toast.error('Erro ao buscar Sistemas.', '',{position:'topRight'});
        })
        .finally(() => {this.loading = false, this.disabledCheckbox = false});
      }
    }
  }
</script>